<template>
	<div class="absolute inset-0 flex items-center justify-center bg-trans-gray z-20" v-show="show">
		<div class="rounded shadow bg-white">
			<div class="rounded-t bg-gray-800 px-4 py-4 text-white font-thin text-lg">
				New Product for {{ categoryName }}
			</div>
			<div class="p-4">
				<div class="mb-2">
					<div class="my-1">
						<label class="block mr-4 text-gray-700 text-sm mb-1">Name</label>
						<input class="w-full appearance-none border rounded py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" :class="{'border-red-500' : errors.name}" type="text" v-model="product.name" placeholder="">
						<p class="text-red-500 text-xs italic mt-1" v-if="errors.name">Required</p>
					</div>
				</div>
				<div class="mb-2">
					<div class="my-1">
						<label class="block mr-4 text-gray-700 text-sm mb-1">Description</label>
						<textarea class="w-full appearance-none border rounded py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" type="number" v-model="product.description" placeholder="" rows="4"></textarea>
					</div>
				</div>
				<div class="mb-2 flex">
					<div class="flex-1 mr-2">
						<label class="block mr-4 text-gray-700 text-sm mb-1">Pack size</label>
						<input class="w-32 appearance-none border rounded py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" :class="{'border-red-500' : errors.pack_size}" type="number" v-model="product.pack_size" placeholder="">
						<p class="text-red-500 text-xs italic mt-1" v-if="errors.pack_size">Required</p>
					</div>
					<div class="flex-1 mr-2">
						<label class="block mr-4 text-gray-700 text-sm mb-1">Unit of measure</label>
						<input class="w-32 appearance-none border rounded py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" :class="{'border-red-500' : errors.unit_measure}" type="text" v-model="product.unit_measure" placeholder="">
						<p class="text-red-500 text-xs italic mt-1" v-if="errors.unit_measure">Required</p>
					</div>
					<div class="flex-1">
						<label class="block mr-4 text-gray-700 text-sm mb-1">Access ID</label>
						<input class="w-32 appearance-none border rounded py-2 px-3 leading-tight focus:outline-none focus:shadow-outline" type="number" v-model="product.access_db_id" placeholder="">
					</div>
				</div>
				<div class="">
					<div class="my-1">
						<label class="inline-block mr-4 text-gray-700 text-sm mb-1">Category:</label>
						<span class="text-sm">{{ categoryName }}</span>
					</div>
				</div>
			</div>
			<div class="rounded-b bg-gray-200 px-4 py-2">
				<div class="flex items-center justify-between">
					<action-button class="link" @button-clicked="cancel">cancel</action-button>
					<action-button class="btn btn-blue" @button-clicked="save">Save</action-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['show', 'accountId', 'catId'],
	data () {
		return {
			errors: {
				name: false,
				pack_size: false,
				unit_measure: false
			},
			product: {
				name: '',
				description: '',
				pack_size: '',
				unit_measure: '',
				access_db_id: '',
				category_id: this.catId,
				parent_id: 0
			}
		}
	},
	methods: {
		checkForErrors () {
			var keys = Object.keys(this.errors)
			for (var i = keys.length - 1; i >= 0; i--) {
				if (this.product[keys[i]].trim() === '') {
					this.errors[keys[i]] = true
				} else {
					keys.splice(i, 1)
				}
			}
			return keys.length
		},
		cancel () {
			this.$emit('close')
		},
		save () {
			if (this.checkForErrors()) return
			this.$http.post('products', this.product)
				.then(response => {
					this.$emit('reload')
					this.$emit('close')
				})
				.catch(err => {
					this.error = err
				})
		}
	},
	computed: {
		categoryName: function () {
			return this.$store.getters.getProductCategoryNameById(this.catId)
		}
	},
	watch: {
		show: {
			immediate: true,
			handler: show => {
				if (show) {
					document.body.style.setProperty('overflow', 'hidden')
				} else {
					document.body.style.removeProperty('overflow')
				}
			}
		}
	},
	created () {
		const listener = document.addEventListener('keydown', e => {
			if (this.show && e.keyCode === 27) {
				this.cancel()
			}
		})

		this.$once('hook:beforeDestroy', () => {
			console.log('removing listener')
			document.removeEventListener('keydown', listener)
			document.body.style.removeProperty('overflow')
		})
	}
}
</script>
